import { Reducer } from 'redux';
import { AuthState, AuthActions, MEMBER_REGISTER_AUTH__FETCH_CAPTCHA_DONE, MEMBER_REGISTER_AUTH__FETCH_MEMBER_PROFILE_DONE, MEMBER_REGISTER_AUTH__SAVE_AUTH_PAGE_DATA, MEMBER_REGISTER_AUTH__RESET_CACHE } from './types';

const initialState: AuthState = {};

const authReducer: Reducer<AuthState, AuthActions> = (state = initialState, action): AuthState => {
  switch (action.type) {
    // 取得圖形驗證碼 完成
    case MEMBER_REGISTER_AUTH__FETCH_CAPTCHA_DONE: {
      return { ...state, captcha: action.payload.response };
    }
    // 取得會員資料 完成
    case MEMBER_REGISTER_AUTH__FETCH_MEMBER_PROFILE_DONE: {
      return { ...state, memberProfile: action.payload.response };
    }
    // 緩存「身分驗證」頁面資料
    case MEMBER_REGISTER_AUTH__SAVE_AUTH_PAGE_DATA: {
      return { ...state, data: { ...action.payload.data, captchaCode: '' } };
    }
    // 重置資料緩存
    case MEMBER_REGISTER_AUTH__RESET_CACHE: {
      return { ...initialState };
    }
    // Default
    default:
      return state;
  }
};

export default authReducer;
